<template>
	<div v-if="server !== null">
		<b-breadcrumb>
			<b-breadcrumb-item text="Home" to="/"/>
			<b-breadcrumb-item text="Servers" to="/servers"/>
			<b-breadcrumb-item :text="server.name" :active="true"/>
		</b-breadcrumb>
		<b-container>
			<b-form @submit="updateServer">
				<b-card no-body>
					<b-tabs card>
						<b-tab title="Details">
							<b-row>
								<b-col lg="6" md="6" sm="12" xs="12">
									<b-form-group id="name-group" label="Name:" label-for="name">
										<b-form-input id="name" type="text" v-model="server.name"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col lg="6" md="6" sm="12" xs="12">
									<b-form-group id="color-group" label="Color:" label-for="color" description="Color for display">
										<b-form-input id="color" type="color" v-model="server.color" required placeholder="Select color"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col lg="6" md="6" sm="12" xs="12">
									<b-form-group id="hostname-group" label="Hostname:" label-for="hostname">
										<b-form-input id="hostname" type="text" v-model="server.hostname"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col lg="6" md="6" sm="12" xs="12">
									<b-form-group id="port-group" label="Port:" label-for="port">
										<b-form-input id="port" type="text" v-model="server.port"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-form-group id="group-group" label="Group:" label-for="name" description="Enter the server group">
										<b-form-input id="group" type="text" v-model="server.group" autofocus required placeholder="Enter server group"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-form-group id="description-group" label="Description:" label-for="description">
										<b-form-textarea id="description" type="text" v-model="server.description" max-rows="5" rows="5"></b-form-textarea>
									</b-form-group>
								</b-col>
							</b-row>
						</b-tab>
					</b-tabs>
				</b-card>
				<b-row>
					<b-col class="d-flex justify-content-end">
						<b-button-group>
							<b-button type="Submit" variant="primary">Save</b-button>
							<b-button @click="cancel()" variant="outline">Back</b-button>
						</b-button-group>
					</b-col>
				</b-row>
			</b-form>
		</b-container>
	</div>
</template>
<script>
import {HTTP} from '../../services/HttpService'

export default {
  name: 'server',
  data: () => ({
    server: null
  }),
  methods: {
    loadServer () {
      HTTP.get('servers/' + this.$route.params.serverId)
      .then(response => {
        this.server = response.data
      })
    },
    updateServer () {
      const formData = new FormData()
      formData.append('name', this.server.name)
      formData.append('hostname', this.server.hostname)
      formData.append('port', this.server.port)
      formData.append('color', this.server.color)
      formData.append('group', this.server.group)
      formData.append('description', this.server.description)
      HTTP.put('servers/' + this.$route.params.serverId, formData)
        .then(response => {
          this.$router.push({
            name: 'ServersPage'
          })
        })
    },
    cancel () {
      this.$router.push({
        name: 'ServersPage'
      })
    }
  },
  created () {
    this.loadServer()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ServerDetailsPage.vue?cac8b2a8